export default __webpack_public_path__ + "static/media/trash-can.5d0e22e2.svg";